import { ArrowLeft } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { useHistory } from 'react-router-dom'
import { useCallback } from 'react'
import { Button } from 'blaze-components/WriterTopBar/Button'

export const BackButton = () => {
  const history = useHistory()

  const goBack = useCallback(() => {
    history.goBack()
  }, [history])

  return (
    <Button icon={ArrowLeft} aria-label="Back" onPress={goBack}>
      <Text>Back</Text>
    </Button>
  )
}
